import { combineReducers } from "redux";

import conceptsFeedback from './conceptsFeedbackReducer';
import concepts from './conceptsReducer';
import display from './displayReducer';
import fillInBlankConceptsFeedback from './fillInBlankConceptsFeedbackReducer';
import fillInBlank from './fillInBlankQuestionsReducer';
import filters from './filtersReducer';
import generatedIncorrectSequences from './generatedIncorrectSequencesReducer';
import grammarActivities from './grammarActivitiesReducer';
import massEdit from './massEditReducer';
import questions from './questionsReducer';
import responses from './responsesReducer';
import session from './sessionReducer';

import { IState } from "../store/configStore";

export const initState: IState = {
  conceptsFeedback: {},
  concepts: {},
  display : {},
  fillInBlankConceptsFeedback: {},
  fillInBlank: {},
  filters: {},
  generatedIncorrectSequences: {},
  grammarActivities: {},
  massEdit: {},
  questions: {},
  responses: {},
  session: {},
};

export const rootReducer = combineReducers({
  conceptsFeedback,
  concepts,
  display,
  fillInBlankConceptsFeedback,
  fillInBlank,
  filters,
  generatedIncorrectSequences,
  grammarActivities,
  massEdit,
  questions,
  responses,
  session,
});
